module.exports = __webpack_public_path__ + "img/icon_oxygenation.3bc37138.png";